export enum RentalPartner {
  PORSCHE_DRIVE = 'PORSCHE_DRIVE',
}
